import { setUser, withScope, captureException } from "@sentry/react";

// Set user context (call this after user login)
export const setUserContext = (user) => {
  setUser({ id: user.id });
};

// Clear user context (call this on logout)
export const clearUserContext = () => {
  setUser(null);
};

// Capture custom events with context
export const captureClientError = (error, context = {}) => {
  withScope(scope => {
    // Set a single context with all the data grouped together
    scope.setContext('client_error_context', context);
    
    // Set specific tags for filtering/searching
    if (context.component) {
      scope.setTag('component', context.component);
    }
    
    scope.setTag('error_source', 'client');
    captureException(error);
  });
};

// Capture Cube.js specific errors
export const captureCubeError = (error, query, cubeContext = {}) => {
  withScope(scope => {
    scope.setTag('error_type', 'cube_query_error');
    scope.setTag('error_source', 'client');

    let processedQuery = query;
    let processedContext = cubeContext;

    // If query is not an object with expected Cube.js properties, 
    // assume it might be context passed as second argument
    if (query && typeof query === 'object' && !query.dimensions && !query.measures && !query.timeDimensions) {
      processedQuery = null;
      processedContext = { ...query, ...cubeContext };
    }

    let queryString = 'No query provided';
    if (processedQuery) {
      try {
        queryString = JSON.stringify(processedQuery);
      } catch (err) {
        queryString = '[Query serialization failed: circular reference]';
      }
    }

    scope.setContext('cube_query', {
      query: queryString,
      query_type: processedQuery ? typeof processedQuery : 'unknown',
      error_message: error?.message || String(error) || 'Unknown error',
      error_name: error?.name || 'Unknown',
      error_stack: error?.stack ? error.stack.substring(0, 500) : 'No stack trace', // Limit stack trace length
      ...processedContext
    });

    // Ensure we have a valid error object to capture
    let errorToCapture = error;
    if (!(error instanceof Error)) {
      errorToCapture = new Error(String(error));
      // Preserve original stack if present
      if (error?.stack) {
        errorToCapture.stack = error.stack;
      }
    }
    captureException(errorToCapture);
  });
};